import axios from "@axios";

export default class Service {
  static updateProperty(payload) {
    var toSend = new FormData();
    for (const key in payload.form) {
      if (Object.hasOwnProperty.call(payload.form, key)) {
        const element = payload.form[key];
        toSend.append(key, element);
      }
    }
    toSend.append("_method", "PUT");
    return axios.post(payload.ep, toSend).then((res) => res);
  }
  static addProperty(payload) {
    var toSend = new FormData();
    for (const key in payload.form) {
      if (Object.hasOwnProperty.call(payload.form, key)) {
        const element = payload.form[key];
        toSend.append(key, element);
      }
    }
    return axios.post(payload.ep, toSend).then((res) => res);
  }
  static deleteProperty(payload) {
    return axios.delete(payload.ep).then((res) => res);
  }
}
